import React from 'react'
import BRDashboard from './BRDashboard'
import Dashboard from './Dashboard'

export default function SZDashboard() {
  const pref = localStorage.getItem('pref')
  const showBRDashboard = JSON.parse(pref);
  const isAdmin = localStorage.getItem("isAdmin");
  const isAdminFlag = JSON.parse(isAdmin);
  return (
    <div>
      {
        showBRDashboard?.hs_code && isAdminFlag  ? <BRDashboard /> : <Dashboard />
      }
    </div>
  )
}
